import React from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { Row, Col, DatePicker, TimePicker, Select } from 'antd';

const ExcelFilterModal = ({
    show,
    handleClose,
    excelFilters,
    setExcelFilters,
    deviceOptions,
    isLoadingDevices,
    handleSelectChangeExcel,
    descargarExcel,
    resetExcelFilters
}) => {
    return (
        <Modal show={show} onHide={handleClose} dialogClassName="modal-lg modal-dialog-centered">
            <Modal.Header closeButton>
                <Modal.Title className="fw-bold" style={{ color: "#3E4144", fontSize: '20px', fontFamily: 'Montserrat, sans-serif' }}>
                    Configurar Reporte Excel
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row gutter={[16, 16]}>
                    <Col span={12}>
                        <p className="fw-bold">Rango de Fechas</p>
                        <DatePicker className="w-100 mb-2" placeholder="Fecha Inicio" format="DD/MM/YYYY" value={excelFilters.fechaInicioExcel} onChange={(date) => setExcelFilters({ ...excelFilters, fechaInicioExcel: date })} getPopupContainer={trigger => trigger.parentElement} />
                        <DatePicker className="w-100" placeholder="Fecha Fin" format="DD/MM/YYYY" value={excelFilters.fechaFinExcel} onChange={(date) => setExcelFilters({ ...excelFilters, fechaFinExcel: date })} getPopupContainer={trigger => trigger.parentElement} />
                    </Col>
                    <Col span={12}>
                        <p className="fw-bold">Rango de Horas</p>
                        <TimePicker className="w-100 mb-2" placeholder="Hora Inicio" format="HH:mm" value={excelFilters.horaInicioExcel} onChange={(time) => setExcelFilters({ ...excelFilters, horaInicioExcel: time })} getPopupContainer={trigger => trigger.parentElement} />
                        <TimePicker className="w-100" placeholder="Hora Fin" format="HH:mm" value={excelFilters.horaFinExcel} onChange={(time) => setExcelFilters({ ...excelFilters, horaFinExcel: time })} getPopupContainer={trigger => trigger.parentElement} />
                    </Col>
                </Row>
                <Row gutter={[16, 16]} className="mt-3">
                    <Col span={12}>
                        <p className="fw-bold">Terminales</p>
                        <Select allowClear mode="multiple" className="w-100" placeholder={isLoadingDevices ? "Cargando..." : "Todas las terminales"} value={excelFilters.devicesExcel} onChange={(value) => handleSelectChangeExcel(value, "devicesExcel")} options={deviceOptions} disabled={isLoadingDevices} getPopupContainer={trigger => trigger.parentElement} />
                    </Col>
                    <Col span={12}>
                        <p className="fw-bold">Tarjetas</p>
                        <Select allowClear mode="multiple" className="w-100" placeholder="Todas las tarjetas" value={excelFilters.tarjetasExcel} onChange={(value) => handleSelectChangeExcel(value, "tarjetasExcel")} options={[{ value: "Visa", label: "Visa" }, { value: "MasterCard", label: "MasterCard" }, { value: "American Express", label: "American Express" }, { value: "Carnet", label: "Carnet" }, { value: "Sodexo", label: "Sodexo" }, { value: "SiVale", label: "SiVale" }, { value: "Edenred", label: "Edenred" }, { value: "Monedero", label: "Monedero" }]} getPopupContainer={trigger => trigger.parentElement} />
                    </Col>
                </Row>
                <Row gutter={[16, 16]} className="mt-3">
                    <Col span={8}>
                        <p className="fw-bold">Tipo</p>
                        <Select allowClear mode="multiple" className="w-100" placeholder="Ambos" value={excelFilters.tipoExcel} onChange={(value) => handleSelectChangeExcel(value, "tipoExcel")} options={[{ value: "DEBIT", label: "Debito" }, { value: "CREDIT", label: "Credito" }]} getPopupContainer={trigger => trigger.parentElement} />
                    </Col>
                    <Col span={8}>
                        <p className="fw-bold">Estado</p>
                        <Select allowClear mode="multiple" className="w-100" placeholder="Todos" value={excelFilters.estadoExcel} onChange={(value) => handleSelectChangeExcel(value, "estadoExcel")} options={[{ value: "Aprobada", label: "Aprobada" }, { value: "Rechazada", label: "Rechazada" }, { value: "Devolucion", label: "Devolucion" }]} getPopupContainer={trigger => trigger.parentElement} />
                    </Col>
                    <Col span={8}>
                        <p className="fw-bold">Propinas</p>
                        <Select mode="multiple" className="w-100" placeholder="Ambas" value={excelFilters.propinasExcel} onChange={(value) => handleSelectChangeExcel(value, "propinasExcel")} options={[{ value: "con_propina", label: "Con Propina" }, { value: "sin_propina", label: "Sin Propina" }]} getPopupContainer={trigger => trigger.parentElement} />
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={resetExcelFilters} className="fw-bold" style={{ borderRadius: '20px' }}>Limpiar</Button>
                <Button variant="success" onClick={descargarExcel} className="fw-bold" style={{ borderRadius: '20px' }}>Generar Excel</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ExcelFilterModal;
